import { Fragment, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { getContent } from "@lib/use_content";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function SystemError({ onHide }: { onHide: () => void }): JSX.Element | null {
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchContent() {
      const { data } = await getContent(["beErrSystemError"]);
      setErrorMessage(data?.content.beErrSystemError);
      setLoading(false);
    }
    fetchContent();
  }, []);

  return loading ? null : (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="fixed inset-0 flex items-start px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
      >
        <div className="w-full flex flex-col items-center space-y-4 ">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={true}
            as={Fragment}
            enter="ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="max-w-xl w-full shadow-xl rounded-lg pointer-events-auto ring-1 ring-black/5 overflow-hidden text-white"
              style={{ backgroundColor: "var(--error-background)" }}
            >
              <div className="p-4">
                <div className="flex items-start">
                  <div className="shrink-0">
                    <ExclamationCircleIcon className="h-6 w-6 text-white-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p
                      className="text-base text-white-500"
                      dangerouslySetInnerHTML={{ __html: errorMessage }}
                    />
                  </div>
                  <div className="ml-4 shrink-0 flex">
                    <button
                      aria-label="Close"
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={onHide}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon
                        style={{ backgroundColor: "var(--error-background)" }}
                        className="h-5 w-5  text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
}
